import styled from "styled-components";
import {mq} from './util/media';

const ButtonWrapper = styled.a`

  background: #676060;
  color: #CEBFBF;
  text-decoration: none;

  transition: 0.3s ease-in-out;

  &:hover {
    background: #CEBFBF;
    color: #676060;
    cursor: pointer;
  }
  padding: 0 1.5rem;
  height: 41px;
  border-radius: 40px;
  font-size: 18px;
  line-height: 18px;
  font-weight: 600;
  display: flex;
  align-items: center;
  width: fit-content;
  letter-spacing: 0.5px;
  white-space: nowrap;

  gap: 0.8rem;

  ${mq.lt.md} {
    height: 34px;
    font-size: 15px;


    & svg {
      max-width: 1.5em;
      max-height: 1.5em;
    }
  }

  ${mq.lt.sm} {
    height: 26.47px;
    font-size: 9px;
    padding:0 1rem;

    gap: 0.6rem;

    & svg {
      max-width: 1.15em;
      max-height: 1.15em;
    }
  }

  svg path {
   stroke: currentColor;   
  }


`

// const Icon = styled.span`
//   background: red;
//   display: inline-block;
//   width: 1rem;
//   height: 1rem;
// `

function Button (props) {
  return (
    <ButtonWrapper href={props.link? props.link : "https://google.com"} target="_blank" className="btn">

      {props.type === "save" &&
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M18.5 12.65V16.35C18.5 19.47 15.59 22 12 22C8.41 22 5.5 19.47 5.5 16.35V12.65C5.5 15.77 8.41 18 12 18C15.59 18 18.5 15.77 18.5 12.65Z" stroke="#CEBFBF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M18.5 7.65C18.5 8.56 18.25 9.4 17.81 10.12C16.74 11.88 14.54 13 12 13C9.46 13 7.26 11.88 6.19 10.12C5.75 9.4 5.5 8.56 5.5 7.65C5.5 6.09 6.22999 4.68 7.39999 3.66C8.57999 2.63 10.2 2 12 2C13.8 2 15.42 2.63 16.6 3.65C17.77 4.68 18.5 6.09 18.5 7.65Z" stroke="#CEBFBF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M18.5 7.65V12.65C18.5 15.77 15.59 18 12 18C8.41 18 5.5 15.77 5.5 12.65V7.65C5.5 4.53 8.41 2 12 2C13.8 2 15.42 2.63 16.6 3.65C17.77 4.68 18.5 6.09 18.5 7.65Z" stroke="#CEBFBF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      }

      {props.type === 'webapp' &&
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M4.83 1.5H13.1625C15.8325 1.5 16.5 2.1675 16.5 4.83V9.5775C16.5 12.2475 15.8325 12.9075 13.17 12.9075H4.83C2.1675 12.915 1.5 12.2475 1.5 9.585V4.83C1.5 2.1675 2.1675 1.5 4.83 1.5Z" stroke="#CEBFBF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M9 12.915V16.5" stroke="#CEBFBF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M1.5 9.75H16.5" stroke="#CEBFBF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M5.625 16.5H12.375" stroke="#CEBFBF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      }
      
      {props.children}
    </ButtonWrapper>
  )
}

export default Button;